<template>
  <v-content>
    <v-card class="mb-3">
      <v-card-title>{{this.$store.getters["report/header"].title}}</v-card-title>
      <v-card-text>
        <table>
          <tr v-if="header.sd">
            <td>{{_l_period}}</td>
            <td>{{$moment(headers.sd).format("DD-MM-YYYY")+" ~ "+$moment(header.ed).format("DD-MM-YYYY")}}</td>
          </tr>
          <tr v-if="header.search!=''">
            <td>{{_l_search}}</td>
            <td>{{header.search}}</td>
          </tr>
          <template v-for="(v,k) in header.filter">
            <tr v-if="v!=''" :key="k">
              <td>{{$t('report.filter_'+k)}}</td>
              <td>{{autoformat_filter(k,v)}}</td>
            </tr>
          </template>
        </table>
      </v-card-text>
    </v-card>
    <v-simple-table>
      <thead>
        <tr class="report-row-header">
          <th v-for="col in columns" class="text-left" :key="col.value">{{col.text}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,i) in report" :key="item.id" :class="'report-row data-row-'+i%2">
          <td v-for="col in columns" :key="col.value">
            <span>{{ autoformat(col.value,item[col.value]) }}</span>
          </td>
        </tr>
        <tr class="report-footer">
          <td
            v-for="col in columns"
            :key="col.value"
            :class="'total-cell-common total-cell-'+col.value"
          >
            <span>{{ autoformat('t.'+col.value,footer.totals[col.value]) }}</span>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-content>
</template>
<script>
//import app from "@/app.js";

export default {
  data() {
    return {
      report: [],
      header: {
        title:""
      },
      footer: {
        totals: {}
      },
      columns: [],
    };
  },
  computed: {
    _l_created() {
      return this._label("report.created");
    },
    _l_search() {
      return this._label("report.search");
    },
    _l_period() {
      return this._label("report.period");
    },
    total4(v) {
      return this.footers.totals[v]
        ? this.autoformat(this.footers.totals[v])
        : "";
    }
  },
  mounted() {
    try {
      this.report = this.$store.getters["report/data"];
      //console.log(this.$store.getters["report/data"])
      //console.log(this.$store.getters["report/header"])
      this.header = this.$store.getters["report/header"];
      this.footer = this.$store.getters["report/footer"];
      this.columns = this.$store.getters["report/columns"];
      // this.report = app.deserializeData();
      // this.headers = app.deserializeHeaders();
      // this.footers = app.deserializeFooters();
      // this.columns = app.deserializeColumns();
      // this.$i18n.locale = localStorage.getItem("lang");
      // this.$root.$emit(
      //   "set_footer_message",
      //   this.$t("report.prepared") + ": " + this.$moment().format("lll")
      // );
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    _label(l) {
      return this.$t(l);
    },
    autoformat(col, val) {
      //console.log(this.$options.filters.currency);
      if (col == "amount1") return this.$options.filters.currency(val);
      if (col == "amount2") return this.$options.filters.currency(val);
      if (col == "t.amount1") return this.$options.filters.currency(val);
      if (col == "t.amount2") return this.$options.filters.currency(val);
      if (col == "created") return this.$options.filters.created(val);
      if (col == "status") return this.$t("status." + val);
      if (val === "undefined") return "";
      return val;
    },
    autoformat_filter(k, v) {
      if (k == "status") return this.$t("status." + v);
      return v;
    }
  }
};
</script>
<style lang="scss" scoped>
.report-row-header {
  background-color: lightgray;
}
.data-row-1 {
  background-color: aliceblue;
}
.report-footer {
  background-color: beige;
}
</style>